import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTopOffset({
	offsetPercent = 10,
	behavior = 'auto',
}) {
	const location = useLocation();

	useLayoutEffect(() => {
		const topOffset = Math.max(
			0,
			Math.round(window.innerHeight * (offsetPercent / 100)),
		);

		window.scrollTo({
			top: topOffset,
			left: 0,
			behavior,
		});
	}, [location.pathname, location.search, offsetPercent, behavior]);

	return null;
}
